/***
*
*   SIGN UP STEP 2
*   Verify email address
*   Step 1: create account
*   Step 2: verify email address
*   Step 3: select plan
*
**********/

import React, { useContext, useState, useEffect, useRef } from 'react';
import Axios from 'axios';
import { AuthContext, Animate, Row, Card, Message, Link, useLocation, useNavigate } from 'components/lib';

export function SignupVerification(props) {

    const location = useLocation();
    const navigate = useNavigate();
    const qs = location.search;
    const context = useContext(AuthContext);
    const authContext = useRef(useContext(AuthContext));

    useEffect(() => {
        if (authContext?.current?.user?.verified) {
            console.log("Already verified! Redirecting!")
            navigate('/account')
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const [message, setMessage] = useState({

        type: 'info',
        title: !authContext?.permission['signup.verify.view'] ?
            props.t('auth.signup.verify.message.withheld.title')
            : props.t('auth.signup.verify.message.verify.title'),
        text: !authContext?.permission['signup.verify.view'] ?
            props.t('auth.signup.verify.message.withheld.text')
            : props.t('auth.signup.verify.message.verify.text'),
        button: {
            text: authContext?.permission['signup.verify.view'] ? props.t('auth.signup.verify.message.verify.button') : '',
            action: authContext?.permission['signup.verify.view'] ? resendVerificationEmail : undefined
        }
    });

    useEffect(() => {
        const verifyToken = async (token) => {

            try {

                setMessage({

                    type: 'info',
                    title: props.t('auth.signup.verify.message.verifying.title'),
                    text: props.t('auth.signup.verify.message.verifying.text'),
                    button: false,

                })

                const res = await Axios.post('/api/user/verify', { token: token });
                Axios.defaults.headers.common['Authorization'] = 'Bearer ' + res.data.token;
                authContext.current.update({ verified: true, token: res.data.token });
                setMessage({

                    type: 'success',
                    title: props.t('auth.signup.verify.message.success.title'),
                    text: props.t('auth.signup.verify.message.success.text'),
                    button: false,

                })
                setTimeout(() => {
                    context.signout();
                }, 3000);
                // return navigate(authContext.current.user.role === 'user' ? '/welcome' : '/signup/plan');

            }
            catch (err) {

                // // token isnt for this account, force signout
                if (err.response?.status === 401)
                    return authContext.current.signout();

                setMessage({

                    type: 'error',
                    title: props.t('auth.signup.verify.message.error.title'),
                    text: props.t('auth.signup.verify.message.error.text'),
                    button: {
                        text: props.t('auth.signup.verify.message.error.button'),
                        action: resendVerificationEmail
                    }
                });
            }
        }

        if (qs.includes('?token=')) {

            // check token exists
            verifyToken(qs.substring(qs.indexOf('?token=') + 7));

        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [qs, authContext, navigate]);

    async function resendVerificationEmail() {

        setMessage({

            type: 'info',
            title: props.t('auth.signup.verify.message.verify.title'),
            text: props.t('auth.signup.verify.message.verify.text'),

        })

        await Axios({ method: 'post', url: '/api/user/verify/request' });

    }

    return (
        <Animate type='pop'>
            <Row title={props.t('auth.signup.verify.title')}>
                <Card loading={false} restrictWidth center>

                    <Message
                        type={message.type}
                        title={message.title}
                        text={message.text}
                        buttonText={message.button?.text}
                        buttonAction={message.button?.action}
                    />

                    {/* <div className='mt-4'>
                        <Link url='/account/profile' text='Manage Your Account' />
                    </div> */}
                    <div className='mt-4' onClick={() => { context.signout() }}>
                        <Link text={props.t('auth.signup.verify.footer.link_text')} />
                    </div>
                </Card>
            </Row>
        </Animate>
    );
}
